import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import PROVIDER_TYPES from '@/components/resources/providerTypes';

const ZONE_LETTERS = 'abcdef';

const matchesRegionZone = (new_value, region_name, separator) => {
  const prefix = `${region_name || ''}${separator}`;
  if (!new_value.startsWith(prefix) || new_value.length !== prefix.length + 1) {
    return false;
  }
  return ZONE_LETTERS.includes(new_value.at(-1));
};

const getZoneHint = (provider_type, region_name) => {
  if (provider_type === PROVIDER_TYPES.AZURE.value) {
    return 'Enter a numeric availability zone (for example, 1)';
  }
  if (provider_type === PROVIDER_TYPES.GCP.value) {
    return `Enter an availability zone as ${region_name}-[a-f] (for example, ${region_name}-a)`;
  }
  if (provider_type === PROVIDER_TYPES.AWS.value) {
    return `Enter an availability zone as ${region_name}[a-f] (for example, ${region_name}a)`;
  }
  return 'Enter the availability zone to create the node in';
};

const getZoneError = (new_value, provider_type, region_name) => {
  if (new_value === '') {
    return false;
  }
  if (provider_type === PROVIDER_TYPES.AZURE.value) {
    if (!/^\d+$/.test(new_value)) {
      return 'Zone must be a number (for example, 1)';
    }
    return false;
  }
  if (provider_type === PROVIDER_TYPES.GCP.value) {
    if (!matchesRegionZone(new_value, region_name, '-')) {
      return `Zone must be ${region_name}-[a-f] (for example, ${region_name}-a)`;
    }
    return false;
  }
  if (provider_type === PROVIDER_TYPES.AWS.value) {
    if (!matchesRegionZone(new_value, region_name, '')) {
      return `Zone must be ${region_name}[a-f] (for example, ${region_name}a)`;
    }
    return false;
  }
  return false;
};

export default function ZoneField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  provider_type,
  region_name,
  edit,
}) {
  const handleChange = (event) => {
    const { value: new_value } = event.target;
    setChanged();
    setValue(new_value);
    setError(getZoneError(new_value, provider_type, region_name));
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Availability Zone'
          id='zone'
          aria-describedby='zone-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='zone-helper-text' error>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='zone-helper-text'>
            {getZoneHint(provider_type, region_name)}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
